/**
 * Posicionamento dinâmico dos painéis de filtro (Tipo / Status / Período).
 *
 * Os painéis abrem ancorados no gatilho (`top: 100%; left: 0` no CSS). Quando o
 * gatilho está perto da borda direita — caso do último filtro da linha — o painel
 * vazava para fora da tela. Este mixin mede o espaço livre no viewport ao abrir
 * (e a cada resize enquanto aberto) e inverte o lado de abertura quando preciso.
 *
 * Contrato para quem usa:
 *   - `ref="raiz"`   no elemento raiz (o wrapper posicionado);
 *   - `ref="painel"` no painel suspenso;
 *   - `:style="estiloPainel"` no painel;
 *   - chamar `observarPosicao()` ao abrir (dentro do $nextTick, com o painel já
 *     renderizado — a medição precisa de dimensões reais) e
 *     `pararObservarPosicao()` ao fechar.
 */

// Folga mínima entre o painel e a borda da janela.
const MARGEM = 12;

export default {
  data() {
    return {
      alinhaDireita: false,
      abreAcima: false,
    };
  },
  computed: {
    estiloPainel() {
      const estilo = {};

      if (this.alinhaDireita) {
        estilo.left = 'auto';
        estilo.right = '0';
      }

      if (this.abreAcima) {
        estilo.top = 'auto';
        estilo.bottom = 'calc(100% + 6px)';
      }

      return estilo;
    },
  },
  methods: {
    ajustarPosicao() {
      const raiz = this.$refs.raiz;
      const painel = this.$refs.painel;

      if (!raiz || !painel) {
        return;
      }

      const caixa = raiz.getBoundingClientRect();
      const largura = painel.offsetWidth;
      const altura = painel.offsetHeight;

      // Só inverte se do outro lado realmente couber; caso contrário mantém o
      // alinhamento padrão e deixa o max-width do painel cuidar do resto.
      const vazaDireita = caixa.left + largura > window.innerWidth - MARGEM;
      const cabeAEsquerda = caixa.right - largura >= MARGEM;
      this.alinhaDireita = vazaDireita && cabeAEsquerda;

      const vazaAbaixo = caixa.bottom + altura > window.innerHeight - MARGEM;
      const cabeAcima = caixa.top - altura >= MARGEM;
      this.abreAcima = vazaAbaixo && cabeAcima;
    },
    observarPosicao() {
      this.ajustarPosicao();
      window.addEventListener('resize', this.ajustarPosicao);
    },
    pararObservarPosicao() {
      window.removeEventListener('resize', this.ajustarPosicao);
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.ajustarPosicao);
  },
};
